import React, {Component} from 'react';
import { change } from 'redux-form';
import Checkbox from 'material-ui/Checkbox';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import {FieldTitle} from "admin-on-rest";
import {getRituals} from "../restClient";

const styles = {
    block: {
        margin: '1rem 0',
        maxWidth: 250,
    },
    label: {
        color: 'rgba(0, 0, 0, 0.298039)',
    },
    radioButton: {
        marginBottom: 16,
    },
};

function propName(obj, value) {
    let res = '';
    for (const i in obj) {
        if (typeof obj[i] === 'object') {
            if (propName(obj[i], value)) {
                return res;
            }
        } else {
            if (obj[i] === value) {
                res = i;
                return res;
            }
        }
    }
    return undefined;
}

class RitualsRadioInput extends Component {
    constructor(props) {
        super(props);

        const {value} = props.input;
        this.state = {
            currentSelected: this.getCurrentSelectedRitual(value),
            currentValue: value,
            defaultChecked: !!value,
            rituals: [],
            checked: !!value,
        };
    }

    componentDidMount() {
        getRituals().then((rituals = []) => {
            let { currentSelected } = this.state;
            if (!currentSelected) {
                const [firstRitual] = rituals;

                currentSelected = firstRitual.identifier;

                this.setState((prevState) => ({
                    ...prevState,
                    currentSelected,
                }));
            }

            const defaultValue = this.generateRitualsValue(rituals);
            defaultValue[currentSelected] = 1;

            this.setState((prevState) => ({
                ...prevState,
                rituals: rituals,
                currentValue: defaultValue,
            }));
        })
    }

    generateRitualsValue = (rituals = []) => {
        return rituals.reduce((a, v) => ({ ...a, [v.identifier]: 0}), {});
    }

    getCurrentSelectedRitual = (value) => {
        return value && typeof value === 'object' ? propName(value, 1) : null;
    }

    handleToggle = (event, ritualAlias) => {
        const { currentValue } = this.state;
        const currentAlias = this.getCurrentSelectedRitual(currentValue);

        currentValue[ritualAlias] = 1;
        currentValue[currentAlias] = 0;
        this.setState((prevState) => ({
            ...prevState,
            currentValue,
        }));

        this.setRitualTemplate(ritualAlias);
        this.props.input.onChange(currentValue);
    };

    setRitualTemplate = (ritualAlias) => {
        this.props.meta.dispatch(change(this.props.meta.form, 'ritualTemplate', ritualAlias));
    }

    handleCheckbox = (event, checked) => {
        this.setState((prevState) => ({
            ...prevState,
            checked,
        }));

        const { currentValue, currentSelected } = this.state;
        this.setRitualTemplate(checked ? currentSelected : null);
        this.props.input.onChange(checked ? currentValue : null);
    }

    render() {
        const {
            isRequired,
            label,
            source,
            elStyle,
            resource,
        } = this.props;
        const {
            checked,
            rituals = [],
            defaultChecked,
            currentSelected
        } = this.state;

        if (!rituals.length) {
            return null;
        }

        return (
            <div style={elStyle || styles.block}>
                <Checkbox
                    defaultChecked={defaultChecked}
                    style={styles.radioButton}
                    onCheck={this.handleCheckbox}
                    labelPosition="left"
                    label={<FieldTitle
                        label={label}
                        source={source}
                        resource={resource}
                        isRequired={isRequired}
                    />}
                />
                { checked && (
                    <RadioButtonGroup name={source} onChange={this.handleToggle} defaultSelected={currentSelected}>
                        {rituals.map((item, key) => {
                            return <RadioButton
                                key={key + item.identifier}
                                value={item.identifier}
                                label={item.title}
                                style={styles.radioButton}
                            />;
                        })}
                    </RadioButtonGroup>
                )}
            </div>
        );
    }
}

RitualsRadioInput.defaultProps = {
    addField: true,
    options: {},
};

export default RitualsRadioInput;


// WEBPACK FOOTER //
// ./src/components/ritualsRadio.js